import React, { useState } from "react";
import SideBar from "../SideBar/sideBar";
import { useNavigate } from "react-router-dom";
import '../../index.css';
import { MarkDone } from "../api/Service";
import LockIcon from '@mui/icons-material/Lock';

const RemovePublicRecords = () => {
    const navigate = useNavigate();
    const FirstName = localStorage.getItem('firstName') || '';
    const LastName = localStorage.getItem('lastName') || '';
    const initials = `${FirstName.charAt(0)}${LastName.charAt(0)}`;

    const [loading, setLoading] = useState(false);
    const [isDone, setIsDone] = useState();
    const MarkDone1 = localStorage.getItem('MarkDone');
    const PlanTypeName = localStorage.getItem('PlanTypeName')

    const handleMarkDone = async () => {
        console.log('hiiii')
        setLoading(true);
        try {
            const response = await MarkDone();
            console.log("MarkDone", response)
            if (response) {
                setIsDone(response.status);
                localStorage.setItem('MarkDone', response.status)
            }


        } catch (error) {
            console.error("Error during API call:", error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="flex h-100% bg-[#121212]">
            <SideBar />
            <main className="flex-1 overflow-y-auto p-6 min-h-screen">
                <div className="flex flex-col md:flex-row justify-between items-center mt-5 mb-4">
                    <h1 className="text-2xl md:text-3xl font-bold text-white">AI Remove Public Legal Data</h1>
                    <div className="ml-0 md:ml-[30.75rem] mt-4 md:mt-0">
                        {PlanTypeName?.includes('Lifetime Access') && (
                            <h1 className="text-white font-semibold">You Have Lifetime Access</h1>
                        )}
                    </div>
                    <div className="w-10 h-10 bg-purple-500 rounded-full flex items-center justify-center mt-4 md:mt-0">
                        <span className="text-white font-bold">{initials}</span>
                    </div>
                </div>
                <div className="videoyou bg-[#1E1E1E] sm:p-4 rounded-lg mx-auto mb-8" style={{ height: "500px", maxWidth: "850px" }}>
                    <div className="relative h-full">
                        <iframe
                            width="100%"
                            height="100%"
                            src="https://player.vimeo.com/video/1021520370"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                            title="Video"
                            className="absolute inset-0 rounded-lg"
                        ></iframe>

                    </div>

                    <div className="button">
                        <div className=" justify-center space-x-4 mb-4">
                            {PlanTypeName === 'Free' ?
                                (<><div className="centerbtn">

                                    <button className="mt-8 px-6 py-3 bg-purple-600 text-white font-semibold rounded-lg hover:bg-purple-700 transition duration-300" onClick={() => navigate('/app/subscription')}>
                                        Remove Public Records <LockIcon className='mr-2' />
                                    </button>

                                </div>
                                    <div className="textcenter">
                                        <div className="mt-8 w-full max-w-3xl">
                                            {MarkDone1 === 'false' && !isDone ? (
                                                <button
                                                    onClick={() => navigate('/app/subscription')}
                                                    className="w-full px-6 py-3 bg-green-600 text-white font-semibold rounded-lg hover:bg-green-700 transition duration-300"
                                                >
                                                    Mark as done <LockIcon className='mr-2' />
                                                </button>
                                            ) : (
                                                <></>
                                            )}
                                        </div>
                                    </div></>)

                                : (<><div className="centerbtn">
                                    <a href="https://optout.lexisnexis.com/" target="_blank" rel="noopener noreferrer">
                                        <button className="mt-8 px-6 py-3 bg-purple-600 text-white font-semibold rounded-lg hover:bg-purple-700 transition duration-300">
                                            Remove Public Records
                                        </button>
                                    </a>
                                </div>
                                    <div className="textcenter">
                                        <div className="mt-8 w-full max-w-3xl">
                                            {MarkDone1 === 'false' && !isDone ? (
                                                <button
                                                    onClick={handleMarkDone}
                                                    className="w-full px-6 py-3 bg-green-600 text-white font-semibold rounded-lg hover:bg-green-700 transition duration-300"
                                                >
                                                    Mark as done
                                                </button>
                                            ) : (
                                                <div className="text-center">
                                                    <p className="text-xl font-bold text-white mb-4">Completed Task</p>
                                                    <p className="text-sm text-gray-400">
                                                        Great! Our system will reach out to LexisNexis every 30 days to ensure that no public records are added. As long as you have an active subscription, we will send these alerts to them every 30 days.
                                                    </p>
                                                </div>
                                            )}
                                        </div>
                                    </div></>)}

                        </div>

                    </div>
                    <iframe
                        style={{ width: '100%', height: '800px' }}
                        className="text-white"
                        src="https://www.create.xyz/app/7e10aede-2b67-4f40-b4ed-4d6eba61cbee"
                        title="Copy of Animated FAQ Section"
                        frameBorder="0"
                    />
                </div>

            </main>
        </div>
    );
};

export default RemovePublicRecords;